import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useContext } from "react";

import Context from "../context";

// ----------------------------------------------------------------------

export const PositionTypeToggle = () => {
	const { state, actions } = useContext(Context);

	return (
		<ToggleButtonGroup
			color='primary'
			value={state.positionType}
			exclusive
			onChange={() => actions.setPositionType(state.positionType === "FUND" ? "PP" : "FUND")}
		>
			<ToggleButton value='FUND' sx={{ py: 0.6 }}>
				<Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
					<Typography variant='button'>Fondos</Typography>
				</Stack>
			</ToggleButton>
			<ToggleButton value='PP' sx={{ py: 0.6 }}>
				<Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
					<Typography variant='button'>PP</Typography>
				</Stack>
			</ToggleButton>
		</ToggleButtonGroup>
	);
};

export default PositionTypeToggle;
